// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mgl-simple-locale[data-v-036c278a] {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n}", ""]);
// Exports
module.exports = exports;
